export default __webpack_public_path__ + "static/media/image2.636a74f0.png";